// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"72":"Cart","187":"NotFound"}[chunkId] + "." + {"72":"89844861","187":"21e125ae"}[chunkId] + ".chunk.css";
};